"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIActionPositionTypes = exports.UIActionIconTypes = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const UIActionPositionTypes = exports.UIActionPositionTypes = {
  TOPBAR_ELLIPSES: "TOPBAR_ELLIPSES"
};
const UIActionIconTypes = exports.UIActionIconTypes = {
  REPORT_ABUSE: "REPORT_ABUSE"
};